export default "__VITE_ASSET__pTmyYb0T__"